import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import LEDControllerOverviewContextProvider from "./context/LEDControllerOverviewContext";
import LEDControllerConfigurationContextProvider from "./context/LEDControllerConfigurationContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {LED_CONTROLLERS, LED_CONTROLLERS_WITH_CONFIG} from "../../util/RouteConstants";
import {FEATURES, FeatureUtility} from "../../util/FeatureUtility";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class LEDControllerPage extends Component {
    render() {
        return (
            FeatureUtility.getFeatureStatus(FEATURES.IS_LED_CONTROLLER_ENHANCEMENT_ENABLED) ?
            <Column>
                <LEDControllerOverviewContextProvider>
                    <LEDControllerConfigurationContextProvider>
                        <TabLayout routes={LED_CONTROLLERS_WITH_CONFIG} location={this.props.location} history={this.props.history}/>
                        <NavigationRoutes routes={LED_CONTROLLERS_WITH_CONFIG}/>
                    </LEDControllerConfigurationContextProvider>
                </LEDControllerOverviewContextProvider>
            </Column>
                :
            <Column>
                <LEDControllerOverviewContextProvider>
                    <TabLayout routes={LED_CONTROLLERS} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={LED_CONTROLLERS}/>
                </LEDControllerOverviewContextProvider>
            </Column>
        )
    }
}

export default LEDControllerPage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontroller/LEDControllerPage.js